import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OauthService, SiteService, AccountSettingService } from '@terradotta/commons';
import { CSSUtils } from '@terradotta/commons';
import { TDAccountSetting } from '@terradotta/commons';
import { debounceTime } from 'rxjs/operators';
import { init as initFullStory } from '@fullstory/browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    "[style.backgroundColor]":"primaryColor"}
})
export class AppComponent {
  title = 'app';

  user: any = {
    userId: 2661,
    // userId: 1576,
    // userId: 1577, // under 18 user
    // userId: 1580, // No applications user
    // userId: 2758, // Group Leader reviewer
    name: 'Terra Dotta'
  };

  primaryColorLoaded: boolean = false;
  primaryColor: string;
  lightPrimaryColor: string;
  loading: boolean = true;
  hasUser: boolean = false;
  applicationId: any;
  fuseAction: string = '';
  useAdminTopbar: boolean = false;
  topbarTitle: string = '';

  constructor(
    private _oauthService: OauthService,
    private route: ActivatedRoute,
    private _siteService: SiteService,
    private _accountSettingService: AccountSettingService,
  ){
    //FullStory init
    initFullStory({
      orgId: 'o-1V47MT-na1'
     });
  }

  ngOnInit(){
    var that = this;
    that.loading = true;
        that.route.queryParams.pipe(
          debounceTime(300)
        ).subscribe(data => {
          that.fuseAction = data['FuseAction'];            
          switch(that.fuseAction){
            case 'Security.AngLogin':
            case 'Security.AngSupportLogin':
            case 'Students.AngApply':
              that.useAdminTopbar = false;
            break;
          }
          that.loading = false;
          that.getAccountSettings();
        })
  }    

  getAccountSettings(){
    var that = this;
    that._accountSettingService.getByName('_sCustomColor','v2').subscribe((resp: TDAccountSetting) => {
      if(resp){
        var customColor = resp.settingValue;
        if(customColor && customColor !== ''){
          CSSUtils.fixPrimaryColor(customColor);
          that.primaryColorLoaded = true;
          that.primaryColor = customColor;
          if(that.primaryColor && CSSUtils.isHexColor(that.primaryColor)){
            that.lightPrimaryColor = CSSUtils.hexToRgba(that.primaryColor,0.07);
          }
        } else {
          that._accountSettingService.getByName('_sColorCSS','v2').subscribe((resp: TDAccountSetting) => {
            if(resp){
              var color = CSSUtils.defaultColorsMap(resp.settingValue);
              if(color){
                CSSUtils.fixPrimaryColor(color);
                that.primaryColorLoaded = true;
                that.primaryColor = color;
                if(that.primaryColor && CSSUtils.isHexColor(that.primaryColor)){
                  that.lightPrimaryColor = CSSUtils.hexToRgba(that.primaryColor,0.07);
                }
              }
            }
          },err => {
            CSSUtils.fixPrimaryColor(null);
            that.primaryColorLoaded = true;
          });
        }
      }
    },err => {
      that._accountSettingService.getByName('_sColorCSS','v2').subscribe((resp: TDAccountSetting) => {
        if(resp){
          var color = CSSUtils.defaultColorsMap(resp.settingValue);
          if(color){
            CSSUtils.fixPrimaryColor(color);
            that.primaryColorLoaded = true;
            that.primaryColor = color;
            if(that.primaryColor && CSSUtils.isHexColor(that.primaryColor)){
              that.lightPrimaryColor = CSSUtils.hexToRgba(that.primaryColor,0.07);
            }
          }
        }
      },err => {
        CSSUtils.fixPrimaryColor(null);
        that.primaryColorLoaded = true;
      });
    });
  }
}